import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import BadgeComponent, {
  StyledBadge,
  StyledBadgeText,
} from '../Badge.component';
import { RoutesConstant } from '../../constants/routes.constant';

export interface HeaderTabProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  path: string;
  badge?: number;
}

const StyledHeaderTab = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.LABEL};
  transition: all 0.3s;
  cursor: pointer;

  & > a {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 22px 10px;
    gap: 5px;
    transition: all 0.3s;

    &.active {
      position: relative;
      color: ${({ theme }) => theme.colors.BLUE.B400};

      & > ${StyledBadge} {
        background: ${({ theme }) => theme.colors.BLUE.B400};

        & > ${StyledBadgeText} {
          color: white;
        }
      }

      &:after {
        content: '';
        position: absolute;
        left: 5px;
        right: 5px;
        bottom: 0;
        height: 3px;
        background: ${({ theme }) => theme.colors.BLUE.B400};
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }
    }
  }

  :hover {
    color: ${({ theme }) => theme.colors.BLUE.B400};
  }
`;

const HeaderTabComponent = ({ path, badge = 0, children }: HeaderTabProps) => {
  const isRedBadge = path === RoutesConstant.CANDIDATES_GROUPS.REQUESTS;
  return (
    <StyledHeaderTab>
      <NavLink to={path}>
        <span>{children}</span>
        {badge > 0 && (
          <BadgeComponent
            appearance={isRedBadge ? 'danger' : 'default'}
            text={badge}
            rounded
          />
        )}
      </NavLink>
    </StyledHeaderTab>
  );
};

export default HeaderTabComponent;
